<script>
import axios from "axios";
import useSharedData from "@/use/SharedData";
import {ref} from "vue";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import useValidation from "@/use/Validation";

export default {
    setup() {
        const {mxRules} = useValidation();
        const {$route, $refs} = useTools();
        const {loading, dialog} = useSharedData();
        const {getBack} = useSharedMethod();

        const file = ref(null);

        function store() {
            if ($refs.form.validate()) {
                loading.value = true;
                const formData = new FormData();
                formData.append("file", file.value);
                axios.post(`/banks/storeTransferModel/${$route.params.id}`, formData).then(() => {
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            mxRules,
            loading,
            dialog,
            file,
            store,
            getBack
        }
    }
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="600"
    >
        <v-card>
            <w-toolbar color="teal" :title="$t('bank.uploadmodel')"/>
            <v-card-text>
                <v-form ref="form" lazy-validation>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12">
                                <w-label :label="$t('common.file')" required/>
                                <w-file-input
                                    v-model="file"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    :show="true"
                    :loading="loading"
                    @press="store"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>